import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import styled from 'styled-components';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { isType3, userTypeList } from 'main_consts';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  checkboxChange,
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';
import CheckBox from '../../../components/Material/Checkbox';

import Table from '../../../components/Material/Table/index';
import {
  Imaster,
  ImawbQryStat1,
  ImawbQryStat2,
  ImawbQryStat3,
  IsearchResponse,
} from './type';

const DivStyle = styled.div`
  border: 3px outset #1c6ea4;
  margin-bottom: 1rem;
`;

/** 主提單查詢 */
const MawbQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 進出口別
    declType: '1',
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 主號
    mawbNo: '',
    // 貨櫃號碼
    containerNo: '',
    // 分號
    hawbNo: '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    // 是否加入時間查詢
    timeCheck: '0',
    // 報單號碼
    declNo: '',
    // 報單類別
    appType: '',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
  };
  const apiName = 'mawbQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [rowData, setRowData] = useState<Imaster[]>([]);
  const [mawbQryStat1, setMawbQryStat1] = useState<ImawbQryStat1>(
    {} as ImawbQryStat1
  );
  const [mawbQryStat2, setMawbQryStat2] = useState<ImawbQryStat2>(
    {} as ImawbQryStat2
  );
  const [mawbQryStat3, setMawbQryStat3] = useState<ImawbQryStat3>(
    {} as ImawbQryStat3
  );

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      chkCode1: master.chkCode1,
      containerNo: master.containerNo,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      declNo: master.declNo,
      hawbNo: master.hawbNo,
      appType: master.appType,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    const startDate = formatDateTime(
      master.startDate,
      master.startTime,
      'MMdd'
    );
    const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.chkCode1.length > 0 ? `${master.chkCode1}_` : ''
      }${startDate}_${EndDate}_主提單查詢.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      chkCode1: master.chkCode1,
      containerNo: master.containerNo,
      warehouse: master.warehouse,
      declType: master.declType,
      mawbNo: master.mawbNo,
      declNo: master.declNo,
      hawbNo: master.hawbNo,
      appType: master.appType,
      timeCheck: master.timeCheck,
      startDate:
        master.timeCheck === '1'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      endDate:
        master.timeCheck === '1'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const {
      mawbQryList = [],
      mawbQryStat1: mawbQryStat1Temp = {} as ImawbQryStat1,
      mawbQryStat2: mawbQryStat2Temp = {} as ImawbQryStat2,
      mawbQryStat3: mawbQryStat3Temp = {} as ImawbQryStat3,
    } = (result.data.data || {}) as IsearchResponse;
    if ((mawbQryList || [])?.length > 0) {
      setColList(
        getColWidthByField([
          { headerName: '項次', field: 'itemNo' },
          { headerName: '報單號碼', field: 'lastDeclNo' },
          { headerName: '類別', field: 'appType' },
          { headerName: '分號', field: 'hawbNo' },
          { headerName: '申報', field: 'piece' },
          { headerName: '進倉', field: 'gciPiece' },
          { headerName: '出倉', field: 'gcoPiece' },
          { headerName: '通關方式', field: 'goodsStat' },
          { headerName: '申報重量', field: 'weight' },
          { headerName: '進倉重量', field: 'gciWeight' },
          { headerName: '併袋號碼', field: 'expBagNo' },
          { headerName: '船舶航次', field: 'voyageNo' },
          { headerName: '海掛', field: 'vesselRegNo' },
          {
            headerName: master.declType === '1' ? '艙號' : '裝貨單號',
            field: 'manifNo',
          },
          { headerName: '快遞倉站', field: 'warehouse' },
          { headerName: '報關箱號', field: 'boxNo' },
          { headerName: '櫃號', field: 'containerNo' },
        ])
      );
      setRowData(mawbQryList);
      setMawbQryStat1(mawbQryStat1Temp);
      setMawbQryStat2(mawbQryStat2Temp);
      setMawbQryStat3(mawbQryStat3Temp);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (master.mawbNo.length === 0 && master.containerNo.length === 0) {
      enqueueSnackbar('【主號】、【貨櫃號碼】擇一必填。', {
        variant: 'warning',
      });
      return;
    }

    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">主提單查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 主提單查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <HVcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio "
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </HVcGrid>
          </Grid>
          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={2}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進倉日期區間：
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  ['startDate', 'startTime'],
                  ['endDate', 'endTime'],
                ]}
                data={master}
                setDayRange={3}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>主號：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                placeholder="主號、貨櫃號碼 擇一必填"
                maxLength={35}
                value={master.mawbNo}
                name="mawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>貨櫃號碼：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                placeholder="主號、貨櫃號碼 擇一必填"
                maxLength={35}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              分號：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.hawbNo || ''}
                name="hawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              報單號碼：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={14}
                value={master.declNo}
                name="declNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              報單類別：
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={2}
                value={master.appType}
                name="appType"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <DivStyle>
            <Grid container>
              <VcGrid item xs={4} sm={2}>
                主號： {mawbQryStat1.mwbCnt || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                分號： {mawbQryStat1.hwbCnt1 || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                【分號： {mawbQryStat1.hwbCnt2 || 0} 筆
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                併袋： {mawbQryStat1.bagCnt || 0} 筆
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                已進倉報單重量： {mawbQryStat1.totWeight || 0}
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                進倉重量： {mawbQryStat1.totGciWeight || 0}】
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                分號： {mawbQryStat2.hwbCnt3 || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                申報： {mawbQryStat2.piece1 || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉： {mawbQryStat2.gciPiece1 || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                出倉： {mawbQryStat2.gcoPiece1 || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                進倉重量： {mawbQryStat2.gciWeight1 || 0}
              </VcGrid>
            </Grid>

            <Grid container>
              <VcGrid item xs={4} sm={2}>
                併袋： {mawbQryStat3.bagCnt2 || 0} 袋
              </VcGrid>

              <VcGrid item xs={4} sm={1}>
                進： {mawbQryStat3.gciBagSn || 0} 袋
              </VcGrid>

              <VcGrid item xs={4} sm={1}>
                出： {mawbQryStat3.gcoBagSn || 0} 袋
              </VcGrid>
              <VcGrid item xs={4} sm={2}>
                【分號： {mawbQryStat3.tot || 0} 筆
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                申報： {mawbQryStat3.piece2 || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={1}>
                進倉： {mawbQryStat3.gciPiece2 || 0} 件
              </VcGrid>

              <VcGrid item xs={4} sm={1}>
                出倉： {mawbQryStat3.gcoPiece2 || 0} 件】
              </VcGrid>

              <VcGrid item xs={4} sm={2}>
                申報重量： {mawbQryStat3.gciWeight2 || 0}
              </VcGrid>
            </Grid>
          </DivStyle>
          <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          />
        </>
      )}
    </div>
  );
};

export default MawbQry;
